export default __webpack_public_path__ + "static/MVDev-3209f2cc936b69c4c31415cd50cad82f.svg";